import React from "react";
import * as Icons from "lucide-react";
import { SERVICES } from "../../lib/data";

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 bg-[#050505]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-12 lg:px-24">
        <div className="grid md:grid-cols-12 gap-8 mb-16 items-end">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-px w-10 bg-gold"></span>
              <span className="text-[11px] uppercase tracking-[0.32em] text-white/60">
                Services · 01 / 05
              </span>
            </div>
            <h2 className="font-display text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              Five disciplines.
              <br />
              <em className="gold-text-gradient not-italic">One studio</em> obsessed
              <br />
              with measurable growth.
            </h2>
          </div>
          <div className="md:col-span-5 md:pl-8">
            <p className="text-white/60 leading-relaxed">
              Every engagement begins with strategy and ends with results. From a
              first-class website to a market-leading app, we are the long-term partner
              ambitious Manchester operators trust with their digital future.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 auto-rows-[minmax(280px,auto)] gap-4 md:gap-6">
          {SERVICES.map((s, idx) => {
            const Icon = Icons[s.icon] || Icons.Sparkles;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative glass hover:border-gold/30 transition-all duration-500 overflow-hidden ${s.span}`}
              >
                {/* Background image */}
                {s.image && (
                  <div className="absolute inset-0">
                    <img
                      src={s.image}
                      alt={s.title}
                      loading="lazy"
                      className="absolute inset-0 h-full w-full object-cover opacity-30 group-hover:opacity-50 group-hover:scale-105 transition-all duration-[1200ms] grayscale group-hover:grayscale-0"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/85 to-[#050505]/40"></div>
                  </div>
                )}
                <div className="absolute top-6 right-6 text-[11px] uppercase tracking-[0.3em] text-white/40 z-10">
                  0{idx + 1}
                </div>
                <div className="relative z-10 flex flex-col h-full p-8 lg:p-10">
                  <div className="mb-8">
                    <div className="inline-flex h-12 w-12 items-center justify-center border border-gold/40 text-gold group-hover:bg-gold group-hover:text-black transition-colors duration-500 backdrop-blur-md bg-black/30">
                      <Icon size={20} strokeWidth={1.5} />
                    </div>
                  </div>
                  <h3 className="font-display text-white text-2xl lg:text-3xl mb-4 tracking-tight">
                    {s.title}
                  </h3>
                  <p className="text-white/65 leading-relaxed mb-6 flex-1 max-w-prose">
                    {s.desc}
                  </p>
                  <ul className="space-y-2">
                    {s.bullets.map((b) => (
                      <li
                        key={b}
                        className="flex items-center gap-3 text-sm text-white/75"
                      >
                        <span className="h-px w-6 bg-gold/60"></span>
                        {b}
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="absolute -bottom-32 -right-32 h-64 w-64 rounded-full bg-gold/5 blur-3xl group-hover:bg-gold/15 transition-all duration-700"></div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
